import{useContext as e,useMemo as n}from"react";import{OptionsContext as i}from"../context/options-context";function u(t={}){const o=e(i);return n(()=>({...o||{},...t}),[o,t])}export{u as useOptionsContext};
